import React, {Component} from 'react';
import Tooltip from 'components/atoms/tooltip';

class ExclusionInfo extends Component {
    render() {
        const {tooltip = []} = this.props;

        return (
            <Tooltip subject={`Excluded by ${tooltip.join(', ')}`}>
                <i className="badge-exc">!</i>
            </Tooltip>
        );
    }
}

export default ExclusionInfo;
